export default {
  title: 'Media Plan',
  mediaChannels: 'Media Channels'
}
